import { differenceInCalendarMonths, isBefore, startOfDay } from 'date-fns';

/** 1/8 per year → 1/96 per month (≈ 1.0417 %). Straight-line AfA by calendar month. */
const MONTHLY_DEPRECIATION_RATE = 1 / 96;
const USEFUL_LIFE_MONTHS = 96;

/**
 * Book value from gross purchase price and available-from date (not first registration).
 * Counts full calendar months only — same approach as the tax office.
 */
export function calculateBookValue(
  purchasePrice: number,
  availableFrom: Date | string,
  asOf: Date | string = new Date(),
): number {
  if (!Number.isFinite(purchasePrice) || purchasePrice < 0) return 0;

  const from = new Date(availableFrom);
  const to = new Date(asOf);
  if (Number.isNaN(from.getTime()) || Number.isNaN(to.getTime())) return purchasePrice;

  // Not available yet (including later days in the same calendar month).
  if (isBefore(startOfDay(to), startOfDay(from))) return purchasePrice;

  // Monatsgenaue AfA: acquisition month counts as a full month.
  const months = differenceInCalendarMonths(to, from) + 1;
  if (months >= USEFUL_LIFE_MONTHS) return 0;

  return Math.round(purchasePrice * (1 - months * MONTHLY_DEPRECIATION_RATE) * 100) / 100;
}
